import React, { useEffect, useCallback, useState} from 'react';
import { fireStore } from '../../firebaseConfig';
import { collection, getDocs, query, where, deleteDoc, doc, updateDoc,onSnapshot } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

const Request = () => {
  const [signuprequest, setsignuprequest] = useState([]);

    
  const fetchSignupRequest = useCallback(() => {
    try {
      const collectionRef = collection(fireStore, 'SignupRequests');
      const q = query(collectionRef, where('approved', '==', false));
      
      // Use onSnapshot to listen for real-time updates
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const signuprequestList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setsignuprequest(signuprequestList);
      });

      // Cleanup the listener on unmount
      return () => unsubscribe();
    } catch (error) {
      console.error('Error fetching signuprequest:', error);
    }
  }, [setsignuprequest]);


  useEffect(() => {
    const unsubscribe = fetchSignupRequest();

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, [fetchSignupRequest]);



  const Deleteevent = async (id) => {
    const idString = String(id); // Convert id to string
    console.log("Converted ID:", idString); // Log the converted id value
    
    const signupdoc = doc(fireStore, "SignupRequests", idString); // Get reference to the document
    console.log("doc:", signupdoc); // Log the signupdoc object
    
    try {
      await deleteDoc(signupdoc); // Delete the document
      alert("successfully deleted");
    } catch (error) {
      console.error("Error deleting document:", error); // Handle any errors
    }
  };
    
    
      const handleApprove = async (id) => {
        try {
          const docId = String(id); // Convert id to string
          const docRef = doc(db, 'SignupRequests', docId); // Use db from firebaseConfig
          await updateDoc(docRef, { approved: true });
          alert("User Approved");
          setsignuprequest(prevRequests => prevRequests.filter(request => request.id !== docId));
        } catch (error) {
          console.error('Error updating signuprequest:', error);
        }
      };

   

  return (
    <div className="p-8 bg-lightgray">
    <div className="flex flex-col md:flex-row justify-between items-center">
      <h2 className="text-2xl font-semibold mb-4 md:mb-0 font-lato">Requests</h2>
      
    </div>

    <div className="container mx-auto bg-white p-4 mt-2 rounded-lg shadow-lg h-[520px] overflow-y-scroll">
      <div className="overflow-x-auto">
         
      <table className="min-w-full bg-white border">
      <thead>
        <tr className="uppercase text-sm leading-normal">
          <th className="py-3 px-6 text-left font-lato font-bold text-liquidblue font-2xl">Name</th>
          <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Designation</th>
          <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Phone</th>
          <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Password</th>
          <th className="py-3 px-6 text-center font-lato text-liquidblue font-2xl font-bold">Action</th>
        </tr>
      </thead>
      <tbody className="text-gray-600 text-sm font-light">
        {signuprequest.map((request) => (
          <tr key={request.id} className="border-b border-gray-200 hover:bg-gray-100 shadow-xl">
            <td className="py-3 px-6 text-left whitespace-nowrap font-lato font-bold text-black">{request.user?.name}</td>
            <td className="py-3 px-6 text-center font-lato font-bold text-black">{request.user?.role}</td>
            <td className="py-3 px-6 text-center font-lato font-bold text-black">{request.user?.phone}</td>
            <td className="py-3 px-6 text-center font-lato font-bold text-black">{request.password}</td>
            <td className="py-3 px-6 text-center">
              <button onClick={() => Deleteevent(request.id)}
              className="bg-darkred text-white px-4 py-2 rounded-lg font-lato font-bold" >Remove</button>
              <button 
                   onClick={() => handleApprove(request.id)}
              className="bg-darkteal text-white px-4 py-2 rounded-lg font-lato font-bold ml-2" >Approve</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
      </div>
  </div>

   </div>
  )
}



export default Request
